import React from 'react';

const InfoItem = ({ label, value }) => {
    return (
        <div className="info-item">
            <div className="info-label">{label}</div>
            <div className="info-value">{value}</div>
        </div>
    );
};

export default InfoItem;
